<template>
<div class="footer">
  <div class="footer-overlay">
 <div class="footer-section">
  <div class="col-lg-6 col-md-6 no-padding footer-section-left">
   <div class="footer-section-total">
     Total Invoices:
     <span class="order-no">{{invoices.length}}</span>
   </div>
  </div>
  <div class="col-lg-6 col-md-6 no-padding footer-section-right">
   <div class="footer-section-order-list">
    <div class="order-content-list">
      <span class="order-content-title">
        VOUCHER AMOUNT:
      </span> <br/>
      <span class="order-content-number">
        <span class="inr-style">INR </span> {{$invoice.voucherTotal(invoices, 'client')}}
      </span>
    </div>
   </div>
  </div>
 </div>
</div>
</div>
</template>
<script>
import GST from './gst';

export default {
  name: 'Footer',
  components: { GST },
  props: ['invoices'],
  data() {
    return {
      currentRoute: '',
    };
  },
  created() {
    this.currentRoute = this.$router.history.current.name;
  },
};
</script>
<style lang='scss'>
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

.align-right {
  float: right;
  padding: 10px;
  font-family:$fontSemibold;
}
.footer {
  position: fixed;
  width: 97.3%;
  bottom: 0;
  margin-left: -20px;
  background-color: #fff;
  border-bottom: 20px solid #f8f8f8;
  &-overlay{
    position: fixed;
    width:96.6%;
    background-color: #fff;
    bottom: 75px;
  }
  .table-title {
    border-color: transparent;
    margin: 0;
  }
  .card-edit-content{
    margin-top: 5px;
  }
  textarea {
    border: 1px solid #e5e5e5;
    border-radius: 2px;
    width: 100%;
    padding: 10px 0;
    margin-bottom: 20px;
    outline: none;
  }
  .footer-section {
    padding: 8px 15px;
    box-shadow: 0 -2px 7px 0 #F8F8F8;
    height: 60px;
    background: #fff;
    position: fixed;
    width: 97.3%;
    bottom: 0;
    height: min-content;
    border-bottom: 20px solid #f8f8f8;
    .float-right{
      .icon{
      float: right;
      cursor: pointer;
    }
    }
    &-total {
      padding: 10px 5px;
      font-size: 1.8rem;
      color: #404040;
      width: max-content;
      border-radius: 4px;
      margin-right: 15px;
      .order-no {
        font-family:$fontSemibold;
        font-size: 20.8px;
      }
    }
    &-left {
      float: left;
      display: inline-block;
      width: max-content;
      h1 {
        margin: 0;
      }
    }
    &-right {
      float: right;
      display: inline-block;
      padding: 0 20px 0 0;
    }
    &-order-list {
      float: right;
      .order-content-list {
        line-height: 22px;
        text-align: right;
        padding-left: 20px;
            margin-bottom: 6px;
        .order-content-title {
          color: #404040;
          font-size: 1rem;
          font-weight: normal;
          text-transform: uppercase;
          line-height: 12px
        }
        .order-content-number {
          color: #234357;
          font-family:$fontSemibold;
          font-size: 1.6rem;
          line-height: 12px;
        .inr-style {
          font-weight: normal;
          padding: 0 10px 0 0;
          font-size: 1.4rem;
        }
        }
      }
    }
  }
}
.input-field {
  padding: 0 0 10px;
  .content-list {
    display: inline-block;
    input {
      border: 1px solid #e5e5e5;
      height: 30px;
      width: 300px;
      padding: 10px;
      border-radius: 2px;
      outline: none;
    }
  }
}
.collapse {
  padding: 5px 10px 20px;
  &-img {
    text-align: center;
    padding: 0 0 15px;
  }
}
.collapse {
  .card-row-edit {
    margin-bottom: 0;
    box-shadow: none;
    padding: 6px;
  }
  .text-input {
    color: #404040;
    font-family:$fontSemibold;
    font-size: 1.2rem;
    padding: 10px 0 0;
  }
  .card-edit-content {
    input {
      outline: none;
    }
    .col-lg-auto {
      display: inline-grid;
    }
  }
  .content-list-title {
    display: inline-block;
    font-family:$fontBold;
    color: #404040;
    font-size: 1.4rem;
    letter-spacing: 0.35px;
  }
  .card-edit-field {
    padding: 12px 15px 6px;
  }
  .el-radio__label {
    text-transform: capitalize;
  }
  .content{
    &-method{
      font-family:$fontSemibold;
      font-size: 1.4rem;
      color: #404040;
    }
  &-section {
    &-right {
      padding: 0 25px;
      .font-normal{
        .bold{
          font-weight: normal;
        }
      }
    }
  }
}
}
.content-list-title-normal {
  display: inline-block;
  font-weight: normal;
  font-size: 1.2rem;
}
</style>
